import React from 'react';
import withRouter from '../../Components/Common/withRouter';

const ParticlesAuth = ({ children } : any) => {
    return (
        <React.Fragment>
            <div className="login-wrapper d-flex align-items-center justify-content-center text-center">
                <div className="background-shape"></div>
                {/* pass the children */}
                {children}
            </div>
        </React.Fragment>
    );
};

export default withRouter(ParticlesAuth);